import React from "react";
import FaqSection from "./FaqSection";

const FaqPage = () => {
  return (
    <main className="min-h-screen bg-white">
      <FaqSection />
    </main>
  );
};

export default FaqPage;